export const IMAGES = {
  comingSoon: {
    rocket: "/images/coming-soon-rocket.svg",
  },
  whyChooseUs: {
    background: "/images/cardService/emergency-breakdown.png",
  },
  slider: {
    roadsideAssistance1: "/images/slider/roadside-assistance-1.jpg",
    carRepair1: "/images/slider/car-repair-1.jpg",
    towingService1: "/images/slider/towing-service-1.jpg",
  },
  services: {
    batteryJumpstart: "/images/services/battery-jumpstart.jpg",
    flatTyre: "/images/services/flat-tyre.jpg",
    keyLockout: "/images/services/key-lockout.jpg",
    towing: "/images/services/towing.jpg",
    mechanicalFault: "/images/services/mechanical-fault.jpg",
  },
};
